module.exports = __webpack_public_path__ + "img/Mau.a9bb5114.png";